import { inject } from '@angular/core';
import { ColumnFilterOperatorService } from '@shared/services/column-filter-operator.service';
import { GLOBAL_UTILS } from '@shared/tokens/utils.token';
import { Observable } from 'rxjs';
import { BaseSessionFilter } from './base-session-filter';

export class BaseFilter<T> extends BaseSessionFilter<T> {
  protected utils = inject(GLOBAL_UTILS);
  private readonly columnFilterOperatorService = inject(
    ColumnFilterOperatorService
  );

  get clearAll(): Observable<void> {
    return this.columnFilterOperatorService.clearAll;
  }

  get checkStatus(): Observable<void> {
    return this.columnFilterOperatorService.checkStatus;
  }

  constructor() {
    super();
    this.columnFilterOperatorService.clearAll.subscribe(() => {
      const filter = this.selectedFilter();
      if (!filter.isExternal) {
        this.selectedFilter().reset();
        if (this.hasSession()) {
          this.clearFilterByColumn(filter);
        }
        this.checkDisableState();
      }
    });

    this.columnFilterOperatorService.checkStatus.subscribe(() => {
      this.checkDisableState();
    });
  }

  protected checkDisableState(): void {
    const isDisable = this.filterDefinition()!.checkDisableState(
      this.columnFilterOperatorService.filters
    );

    this.isDisabled.set(isDisable);
  }

  protected getValue<TValue>(): TValue {
    return this.utils.parseTo<TValue>(this.value());
  }

  protected update(value: T): void {
    const filterColumn = this.selectedFilter();
    filterColumn.updateValue(value);
    this.updateFilter.next(filterColumn);
  }
}
